import defaultProfileIcon from "../../../assets/icons/default-profile.jpg";
import { useTranslation } from "react-i18next";

const ProfileHeader = ({ username, profileAvatar, onEditAvatar }) => {
    const { t } = useTranslation();

    return (
        <div className="profile-card-header">
            <button
                type="button"
                className="avatar-flip"
                onClick={onEditAvatar}
                aria-label={t("profile.editAvatar")}
            >
                <img
                    src={profileAvatar || defaultProfileIcon}
                    height="150"
                    width="150"
                    alt=""
                />
            </button>
            <h2>{username}</h2>
        </div>
    );
};

export default ProfileHeader;
